/**
 * AddPaymentStatementCommentCtrl controller
 * Add/Edit Payment statement comment
 */

/**
 * AddPaymentStatementCommentCtrl controller
 *
 * @class AddPaymentStatementCommentCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:AddPaymentStatementCommentCtrl
 */
/* @ngInject */
export default function AddPaymentStatementCommentCtrl ($uibModalInstance, statement, allowEdit, alertLiteSvc) {
  var vm = this

  /**
   * PaymentStatement
   *
   * @memberof mwApp/subscribers.controller:AddPaymentStatementCommentCtrl
   * @type {models.PaymentStatement}
   */
  vm.statement = statement

  /**
   * isNew flag
   *
   * @memberof mwApp/subscribers.controller:AddNoteCtrl
   * @type {Boolean}
   */
  vm.isNew = !statement.comment

  /**
   * When true, show the comment form (add new or edit existing). Activated from activation page via resolve.
   *
   * @memberof mwApp/subscribers.controller:AddPaymentStatementCommentCtrl
   * @type {Boolean}
   */
  vm.showEditForm = vm.isNew || allowEdit === true

  /**
   * Create or edit comment, and close modal window afterwards
   *
   * @memberof mwApp/subscribers.controller:AddPaymentStatementCommentCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    statement._comment()
      .then(
        () => {
          $uibModalInstance.close()
        }
      )
      .finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/subscribers.controller:AddPaymentStatementCommentCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  vm.copyComment = function () {
    var text = vm.statement.comment == null ? '' : String(vm.statement.comment)
    if (!text) {
      return
    }
    navigator.clipboard.writeText(text)
    alertLiteSvc.alert('Copied comment', 'success')
  }
}
